import type { TrendGranularity } from '../types/dashboardTrend';

function toDateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`;
}

function parseDateKey(anchor: string): Date {
  const [y, m, d] = anchor.split('-').map((n) => Number(n));
  return new Date(y, (m || 1) - 1, d || 1, 12, 0, 0, 0);
}

export function getTodayAnchor(): string {
  return toDateKey(new Date());
}

export function shiftTrendAnchor(anchor: string, granularity: TrendGranularity, direction: -1 | 1): string {
  const date = parseDateKey(anchor);
  if (granularity === 'day') {
    date.setMonth(date.getMonth() + direction);
    date.setDate(1);
    return toDateKey(date);
  }
  if (granularity === 'week') {
    date.setFullYear(date.getFullYear() + direction);
    return toDateKey(date);
  }
  if (granularity === 'month') {
    date.setFullYear(date.getFullYear() + direction);
    date.setMonth(0);
    date.setDate(1);
    return toDateKey(date);
  }
  date.setFullYear(date.getFullYear() + direction * 10);
  date.setMonth(0);
  date.setDate(1);
  return toDateKey(date);
}

export function buildTrendQueryParams(params: {
  lens: 'personal' | 'org';
  granularity: TrendGranularity;
  anchor: string;
  timezone: string;
  organizationId?: string;
}) {
  return {
    lens: params.lens,
    granularity: params.granularity,
    anchor: params.anchor,
    timezone: params.timezone,
    ...(params.lens === 'org' && params.organizationId ? { organizationId: params.organizationId } : {})
  };
}
